import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Eye, Loader2 } from 'lucide-react';
import { Button } from './ui/button';
import { setHcToken } from '../helpconnect/api';

export const HC_VIEW_RETURN_KEY = 'helpconnect_view_return';

export const HelpConnectViewPortalButton = ({ participantId }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const open = async () => {
    setLoading(true);
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/helpconnect/staff/view-portal/${participantId}`, null, {
        headers: { Authorization: `Bearer ${localStorage.getItem('myhelp_token')}` },
      });
      sessionStorage.setItem(HC_VIEW_RETURN_KEY, window.location.pathname + window.location.search);
      setHcToken(data.token);
      navigate('/helpconnect');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Could not open the portal');
      setLoading(false);
    }
  };
  return (
    <Button variant="outline" size="sm" onClick={open} disabled={loading || !participantId} data-testid="helpconnect-view-portal-btn">
      {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Eye className="w-4 h-4 mr-2" />}View Portal
    </Button>
  );
};
